export {
  activityComponent,
  ActivityPolymiddlewareProxy,
  createActivityPolymiddleware,
  useBuildRenderActivityCallback,
  type ActivityPolymiddleware,
  type ActivityPolymiddlewareHandler,
  type ActivityPolymiddlewareHandlerResult,
  type ActivityPolymiddlewareProps,
  type ActivityPolymiddlewareProxyProps,
  type ActivityPolymiddlewareRenderer,
  type ActivityPolymiddlewareRequest,
  type Polymiddleware
} from 'botframework-webchat-api/middleware.js';

export { createActivityPolymiddlewareFromLegacy } from 'botframework-webchat-api/middleware.js';

export {
  createErrorBoxPolymiddleware,
  errorBoxComponent,
  ErrorBoxPolymiddlewareProxy,
  useBuildRenderErrorBoxCallback,
  type ErrorBoxPolymiddleware,
  type ErrorBoxPolymiddlewareHandler,
  type ErrorBoxPolymiddlewareHandlerResult,
  type ErrorBoxPolymiddlewareProps,
  type ErrorBoxPolymiddlewareProxyProps,
  type ErrorBoxPolymiddlewareRenderer,
  type ErrorBoxPolymiddlewareRequest
} from 'botframework-webchat-api/middleware.js';

export {
  avatarComponent,
  AvatarPolymiddlewareProxy,
  createAvatarPolymiddleware,
  useBuildRenderAvatarCallback,
  type AvatarPolymiddleware,
  type AvatarPolymiddlewareHandler,
  type AvatarPolymiddlewareHandlerResult,
  type AvatarPolymiddlewareProps,
  type AvatarPolymiddlewareProxyProps,
  type AvatarPolymiddlewareRenderer,
  type AvatarPolymiddlewareRequest
} from 'botframework-webchat-api/middleware.js';

export { createAvatarPolymiddlewareFromLegacy } from 'botframework-webchat-api/middleware.js';
